module.exports = __webpack_public_path__ + "static/media/maldiniLogo.3312b8db.png";